<script>
  /**
   * X and Y axes rendered by Svelte. d3-scale provides .ticks() to pick
   * nice values; we render the ticks/lines/labels as SVG ourselves so
   * there's no d3.select(...).call(axisBottom) DOM mutation.
   */
  let { xScale, yScale, innerW, innerH } = $props();

  const xTicks = $derived(xScale.ticks(7));
  const yTicks = $derived(yScale.ticks(5));
  const fmt = (d) => d + '%';
</script>

<!-- X axis -->
<g class="axis axis-x" transform="translate(0,{innerH})">
  <line x1="0" x2={innerW} y1="0" y2="0" />
  {#each xTicks as t (t)}
    <g class="tick" transform="translate({xScale(t)},0)">
      <line y1="0" y2="6" />
      <text dy="0.9em" y="9" text-anchor="middle">{fmt(t)}</text>
    </g>
  {/each}
</g>

<!-- Y axis -->
<g class="axis axis-y">
  <line x1="0" x2="0" y1="0" y2={innerH} />
  {#each yTicks as t (t)}
    <g class="tick" transform="translate(0,{yScale(t)})">
      <line x1="-6" x2="0" />
      <text dy="0.32em" x="-9" text-anchor="end">{fmt(t)}</text>
    </g>
  {/each}
</g>

<text class="axis-title axis-title-x" text-anchor="end" x={innerW} y={innerH + 36}>
  Participación →
</text>
<text class="axis-title axis-title-y" text-anchor="start" x="0" y="-10">
  ↑ Margen del ganador
</text>
